/* SL - Before & after (sections/sl-before-after.liquid): drag-to-compare slider.
   The range input handles keyboard and screen readers. Mouse drags (and clicks) move the divider anywhere on the photo;
   touch drags move it only once the finger travels sideways (touch-action: pan-y), so vertical page scrolling still works. */
(() => {
  if (customElements.get('sl-compare')) return;

  class SlCompare extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.sl-ba__range');
      if (!this.range) return;
      this.range.addEventListener('input', () => this.set(Number(this.range.value)));
      this.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        this.dragging = true;
        if (e.pointerType === 'mouse') {
          e.preventDefault();
          this.setPointerCapture(e.pointerId);
          this.fromPointer(e);
          this.range.focus({ preventScroll: true });
        }
      });
      this.addEventListener('pointermove', (e) => { if (this.dragging) this.fromPointer(e); });
      const stop = () => { this.dragging = false; };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((t) => this.addEventListener(t, stop));
      this.set(Number(this.range.value));
    }

    fromPointer(e) {
      const r = this.getBoundingClientRect();
      const pos = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      this.range.value = Math.round(pos);
      this.set(pos);
    }

    set(pos) {
      this.style.setProperty('--pos', `${pos}%`);
      this.range.setAttribute('aria-valuetext', `${Math.round(pos)}%`);
    }
  }

  customElements.define('sl-compare', SlCompare);
})();
